import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomButton from "../../../components/CustomButton/CustomButton";
import {
  NotFoundContainer,
  NotFoundTitle,
  NotFoundText,
} from "../styles/DetallesPacienteStyles";

const NotFoundState = ({ numeroIngreso, onBack }) => {
  return (
    <CustomLayout showMenuNav={true} footerWidth={"auto"}>
      <Section>
        <NotFoundContainer>
          <NotFoundTitle>Paciente no encontrado</NotFoundTitle>
          <NotFoundText>
            No se encontró información para el número de ingreso:{" "}
            {numeroIngreso}
          </NotFoundText>
          <CustomButton width="100px" onClick={onBack} label="Volver" />
        </NotFoundContainer>
      </Section>
    </CustomLayout>
  );
};

export default NotFoundState;

